export default __webpack_public_path__ + "static/banner-christmas-gift-ideas-for-the-whole-family-ef51cab9f8f8c37eb7c8ff307f4ef9fe.jpg";